export enum UserRole {
    ADMIN = 'ADMIN',
    USER = 'USER'

}
export const ALL_USER_ROLES: Array<UserRole> = Object.values(UserRole);